import React from 'react';
import { AlertDialog, AlertDialogButton } from 'react-onsenui';
import PropTypes from 'prop-types';

class ConfirmModal extends React.Component {

    componentDidUpdate(prevProps) {
        if(this.props.show !== prevProps.show && this.props.show === true) {
            //make pause to worker page live
            try {
                clearInterval(this.props.interval.current);   
            } catch (error) {
                
            }
        }
    }

    render() {
        return (
            <AlertDialog isOpen={this.props.show} onCancel={this.props.onCancel}>
                <div className="alert-dialog-title" style={{textAlign: 'center', marginBottom: '10px'}}>
                    <h6 style={{marginBottom: 0, color: '#004586', fontWeight: '700', fontFamily: 'fff-equipe'}}>{this.props.title ? this.props.title : 'Confirmation'}</h6>
                </div>
                <div className="alert-dialog-content" style={{fontSize: '14px', textAlign: 'center', marginTop: 0, color: '#004586', fontFamily: 'fff-equipe'}}>
                    {this.props.content}
                </div>
                <div className="alert-dialog-footer">
                    <AlertDialogButton onClick={() => {
                        if(!this.props.disabled) {
                            this.props.onOk();
                        }
                    }}>
                        <span style={{fontWeight: '700', textAlign: 'center', color: '#004586', fontFamily: 'fff-equipe', opacity: this.props.disabled ? 0.3 : 1}}>Ok</span>
                    </AlertDialogButton>
                    <AlertDialogButton onClick={this.props.onCancel}>
                        <span style={{fontWeight: '700', textAlign: 'center', color: '#004586', fontFamily: 'fff-equipe'}}>Annuler</span>
                    </AlertDialogButton>
                </div>
            </AlertDialog>
        );
    }
}

ConfirmModal.propTypes = {
    show: PropTypes.bool.isRequired,
    title: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
    onOk: PropTypes.func.isRequired,
    disabled: PropTypes.bool
}

export default ConfirmModal;